namespace Solovis.Reports.Parts.AttributionReport {

  // Data shape produced by the KpiTileArea region's own dataSources (see AttributionReport.js,
  // dataSourceForKpiTiles.postProcess).
  export interface AttributionKpiTileAreaDataSet {
    portfolioReturn: number | null;
    benchmarkReturn: number | null;
    selectionEffect: number | null;
    allocationEffect: number | null;
    interactionEffect: number | null;
    lineItemBenchmarkEffect: number | null;
    showInteractionEffect: boolean;
    showLineItemBenchmarkEffect: boolean;
    asOfLabel: string;
  }

  /**
   * Renders the AR-004 KPI tiles (a portfolio-ui React component) into the Attribution Report's
   * "KpiTileArea" region.
   *
   * Mounts via Solovis.UX.Utils.placeComponent unconditionally -- no renderMode "modern"/"classic"
   * branch like the *ParameterControl.ts classes use. Attribution Report is registered as
   * ReportTypeIds.Classic, so ReportControl would always set renderMode to "classic" here;
   * placeComponent/getComponent don't themselves gate on isNewUxEnabled(), so calling them
   * directly is safe and is the only way these tiles would ever render.
   */
  export class AttributionKpiTileAreaControl extends Solovis.Reports.Parts.PartControl {

    constructor(options: Solovis.Reports.Parts.PartControlOptions) {
      super(options);
    }

    public async doRender() {
      if (!this.dataSets || !this.dataSets.kpiTiles) {
        return;
      }

      const kpi: AttributionKpiTileAreaDataSet = this.dataSets.kpiTiles;

      // The portfolio-ui Tailwind build scopes its utility classes under ".paux" (e.g.
      // ".paux .tw-border") so they can't leak into DataPortal's legacy CSS -- callers of
      // placeComponent are expected to add this class to the mount container themselves
      // (see Solovis.UX.Utils.placeToastComponent for the same pattern).
      this.container.addClass("paux");
      const target = this.container[0];

      await Solovis.UX.Utils.placeComponent("AttributionKpiTiles", target, {
        id: "attribution-kpi-tiles",
        ...kpi
      });
    }
  }
}
